import React, { Fragment } from 'react';
import { Container, Grid, Item, Button } from 'semantic-ui-react';
import PageMetaData from '../../app/common/elements/PageMetaData';
import CompressedImage from '../../app/common/elements/CompressedImage';
export default function HomePage({ history }) {
  return (
    <Fragment>
      <PageMetaData
        title='Home'
        description='Welcome to the language learning library'
        url='/'
      />
      <Container className='pageBody'>
        <CompressedImage
          src='/assets/images/LanguageGroup-1440.jpg'
          jpf={true}
          jxr={true}
          webp={true}
          style={{ width: '100%' }}
        />
        <Grid>
          <Grid.Row>
            <Grid.Column className='computer only' computer={2}></Grid.Column>
            <Grid.Column
              computer={12}
              mobile={16}
              style={{ marginTop: 20, textAlign: 'center' }}
            >
              <Item>
                <Item.Header
                  as={'h3'}
                  style={{ textAlign: 'center' }}
                  content='Hundreds of resources collected BY language learners FOR language learners!'
                />
              </Item>
              <Item.Content style={{ marginTop: 10 }}>
                <p>
                  When starting language learning, it's difficult to find
                  resources that are at the right level. What makes it even more
                  difficult is that most of the "reviews" are little more than
                  advertisements written by people who get commission for you
                  signing up via their site. Looking around, you'll see the same
                  resources recommended again and again. Not because they are
                  the best but because they offer the site the most commission.
                </p>
                <p>
                  The Language Learning Library is different. Users can submit
                  their own reviews so you are seeing good honest reviews from
                  people with nothing to gain other than helping their fellow
                  language learners.
                </p>
                <Button
                  color='blue'
                  content='Search The Library'
                  as='a'
                  href='/search'
                />
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
              </Item.Content>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Fragment>
  );
}
